<template>
  <base-row v-bind="$props">
    <td>
      <a
        :href="route('transfers.index', { transfer: item.transfer.id })"
        target="_blank"
      >
        {{ item.transfer.reference_id }}
      </a>
    </td>
    <td>
      {{ item.sub_lot_num ?? 'N/A' }}
    </td>
    <td>
      {{ item.transfer?.display_status ?? 'N/A' }}
    </td>
    <td>
      {{ item.transfer && item.transfer.origin_id ? getLocationName(item.transfer.origin_id) : defaultLocationName }}
    </td>
    <td>
      {{ location }}
    </td>
    <td>
      {{ item.transfer_quantity_adjusted }}
    </td>
    <td>
      {{ _date(item.transferred_at) }}
    </td>
    <td>
      {{ transferrer }}
    </td>
    <td>
      {{ item.received_at ? _datetime(item.received_at, DateTime.DATETIME_SHORT) : 'N/A' }}
    </td>
    <td>
      {{ receiver }}
    </td>
    <!--        <td>-->
    <!--            <Link v-if="hasRoute"-->
    <!--                  :href="packageShowRoute"-->
    <!--                  class="uppercase font-semibold text-blue-600 hover:underline hover:text-blue-600">-->
    <!--                Edit-->
    <!--            </Link>-->
    <!--        </td>-->
  </base-row>
</template>

<script>
import TableRow from '@/Components/Table/TableRow'
import RowProps from '@/Components/Table/Mixins/RowProps'
import _date from '@/Filters/Date'
import _datetime from '@/Filters/DateTime'
import { Link } from '@inertiajs/vue3'
import accessesCompany from '@/Mixins/accessesCompany'
import { DateTime } from 'luxon'

export default {
  components: {
    'base-row': TableRow,
    Link
  },

  mixins: [RowProps, accessesCompany],

  props: {
    /**
     * A function that we can use to generate the URL to view a package. Returns a string that is a valid URL
     */
    showRoute: {
      type: Function,
      default: (item) => null
    }
  },

  computed: {
    DateTime() {
      return DateTime
    },
    transferrer() {
      return this.item.transferrer?.name || this.item.transferrer?.email || 'N/A'
    },
    receiver() {
      return this.item.receiver?.name || this.item.receiver?.email || 'N/A'
    },
    status() {
      return this?.item?.published_at ? 'Published' : 'Un-published'
    },
    location() {
      return this?.item?.location?.name || this.defaultLocationName
    },
    packageShowRoute() {
      return this.showRoute(this.item)
    },
    hasRoute() {
      return this.packageShowRoute !== null
    },
    locations() {
      return this.$page.props.auth.locations
    }
  },

  methods: {
    _date,
    _datetime,

    getLocationName(locationId) {
      return this.locations.find((location) => location.id === locationId)?.name
    }
  }
}
</script>
